import { h, Component } from 'preact';

import { connect } from 'redux-zero/preact';
import { $lang, resultStatus } from '../../plugins/helper';

import actions from '../../store/actions';
import store from '../../store';

const mapToProps = ({ etest }) => ({ etest });

class ETResult extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.addLeaveEvent(false);
        var can = document.getElementById('canvas'),
        spanPercent = document.getElementById('percent'),
        c = can.getContext('2d');

        var posX = can.width / 2,
            posY = can.height / 2,
            fps = 1000 / 200,
            percent = 0,
            onePercent = 360 / 100,
            result = onePercent * spanPercent.getAttribute("data-percentage");

        c.lineCap = 'round';
        this.arcMove(spanPercent, posX, posY, fps, percent, result, c, can, onePercent);
    }

    arcMove(spanPercent, posX, posY, fps, percent, result, c, can, onePercent) {
        var deegres = 0;
        var acrInterval = setInterval (function() {
            deegres += 1;
            c.clearRect( 0, 0, can.width, can.height );
            percent = deegres / onePercent;

            spanPercent.innerHTML = percent.toFixed();

            c.beginPath();
            c.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 + 360) );
            c.strokeStyle = '#ededed';
            c.lineWidth = '5';
            c.stroke();

            c.beginPath();
            c.strokeStyle = '#49c6fe';
            c.lineWidth = '10';
            c.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 + deegres) );
            c.stroke();
            if( deegres >= result ) clearInterval(acrInterval);
        }, fps);
    }

    /** @return {string|string[]} */
    message(arrPosition) {
        const { etest } = this.props;
        const level = etest.result.certificate_level;

        const state = store.getState();
        const fullname = state.fullname || 'User';

        let messages;

        switch (resultStatus(etest)) {
            case 'ct_passed':
                messages = [$lang('et.result.passed.0',  {fullname, level}), $lang('et.result.passed.1')];
                break;
            case 'ct_review':
                messages = [$lang('et.result.review.0', {level}), $lang('et.result.review.1')];
                break;
            case 'auto_next':
                messages = [$lang('et.result.auto_next.0', {level}), $lang('et.result.auto_next.1')];
                break;
            case 'ct_landing_failed':
                messages = [$lang('et.result.ct_landing_failed.0', {level}), $lang('et.result.ct_landing_failed.1')];
                break;
            default:
                // Default failed
                messages = [$lang('et.result.failed.0'), $lang('et.result.failed.1')];
                break;
        }

        return messages[arrPosition] || null;
    }

    /** @return {JSX.Element} */
    render({etest}) {
        const percentage = etest.result.percentage.replace('%','');

        return (
            <div className="et-container et-px-4 et-mx-auto">
                <h2 className="et-level-title">{etest.result.certificate_level} Certification Test Result</h2>
                <div className="et-flex et-justify-center et-mt-1">
                    <div className="et-text-2xl et-max-w-xl mx-auto">
                        <p id="message-result">{this.message(0)}</p>
                    </div>
                </div>
                <div className="et-flex et-justify-center et-mt-1">
                    <div class="canvas-wrap">
                        <canvas id="canvas"></canvas>
                        <span data-percentage={percentage} id="percent"></span>
                    </div>
                </div>

                <div className="et-mt-1 et-max-w-xl et-mx-auto">
                    <p className="et-text-center">
                        {this.message(1)}
                    </p>
                </div>
            </div>
        )
    }
}

export default connect(mapToProps,actions)(ETResult)